import { useSyncExternalStore } from "react"

// This preference holds no user content and is shared across the entire agent surface.
let paused = false
const listeners = new Set<() => void>()
function subscribe(listener: () => void) {
  listeners.add(listener)
  document.addEventListener("visibilitychange", listener)
  return () => {
    listeners.delete(listener)
    document.removeEventListener("visibilitychange", listener)
  }
}
function snapshot() {
  return paused || document.hidden
}
function serverSnapshot() {
  return true
}

export function useAgentMotion() {
  const motionPaused = useSyncExternalStore(subscribe, snapshot, serverSnapshot)
  return {
    paused: motionPaused,
    toggle: () => {
      paused = !paused
      listeners.forEach((listener) => listener())
    },
  }
}
